<cx-split-view [hideMode]="false">
  @if (structure$ | async; as structure) {
    @if (listData$ | async; as data) {
      <cx-view class="list">
        <div class="header">
          <div class="title unit-overview">
            <h3>
              {{
              'units.header' | cxTranslate: { count: getListCount(data) }
              }}
            </h3>
          </div>
        </div>
        @if (data.values?.length > 0) {
          <cx-table
            [structure]="structure"
            [data]="data.values"
            [i18nRoot]="domainType"
            [currentItem]="{ property: key, value: currentKey$ | async }"
            (launch)="launchItem($event)"
            [cxFocus]="{ trap: 'both' }"
            >
          </cx-table>
        } @else {
          <p class="instruction is-empty">
            {{ 'organization.messages.emptyList' | cxTranslate }}
          </p>
        }
        <div class="footer">
          <cx-pagination
            [pagination]="data.pagination"
            (viewPageEvent)="browse(data.pagination, $event)"
          ></cx-pagination>
        </div>
      </cx-view>
    }
    <!-- nested split views are rendered inside child routes -->
    <router-outlet></router-outlet>
  }
</cx-split-view>


